/// <amd-module name="Wit/Filter/IterationPathFilterProvider" />

import { CoreFieldRefNames } from "Wit/Common/Generated/Constants";
import { WiqlOperators } from "Wit/Common/WiqlOperators";
import { FieldFilterProvider } from "./FieldFilterProvider";
import { IFilter, IFilterProvider } from "./FilterManager";

export class IterationPathFilterProvider extends FieldFilterProvider implements IFilterProvider {
    constructor(private currentIterationPath?: string) {
        super(CoreFieldRefNames.IterationPath);
    }

    public setFilter(filter: IFilter) {
        super.setFilter(filter);

        // Resolve macro filter values
        if (this.currentIterationPath) {
            const filterValues = Object.keys(this._filterValueMap);
            for (const filterValue of filterValues) {
                if (filterValue === WiqlOperators.MacroCurrentIteration) {
                    delete this._filterValueMap[filterValue];
                    this._filterValueMap[this.currentIterationPath] = true;
                }
            }
        }
    }
}
